import React, { useState } from "react";
import Header from "../../components/Header/Header";
import MainContent from "../../components/MainContent/MainContent";
// import ConfirmUserButton from "./components/Confirm";
import Footer from "../../components/Footer/Footer";
import Overlay from "../../components/Overlay/Overlay";
import Video from "../../components/Video/Video";

import styles from "./Home.module.css";

export default function Home() {
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);
  const [isVideoOpen, setIsVideoOpen] = useState(false);
  const handleToggleOverlay = () => {
    setIsOverlayOpen(!isOverlayOpen);
  };
  const handleToggleVideo = () => {
    setIsVideoOpen(!isVideoOpen);
  };
  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        {/* <div className={styles.portraitContainer} onClick={handleToggleVideo}>
          <img
            src="/images/portrait.jpg"
            alt="Victor Küppers"
            className={styles.portrait}
          />
          <button className={styles.playButton} onClick={handleToggleVideo}>
            <img src="/images/play.svg" alt="Play" />
          </button>
        </div> */}
        {isVideoOpen && <Video handleCloseVideo={handleToggleVideo} />}
        {isOverlayOpen && <Overlay handleToggleOverlay={handleToggleOverlay} />}
        <Header />
        <MainContent
          handleOpenOverlay={handleToggleOverlay}
          handleToggleVideo={handleToggleVideo}
        />
        <Footer />
      </div>
    </div>
  );
}
